<!-- 头条推广中心页面 -->
<template>
  <div class="toutiao">
    <div class="toutiao-extendingCenter theme-base" v-wechat-title="'推广中心'">
      <!--搜索栏-->
      <div class="toutiao-extendingCenter-search">
        <v-touch class="search-box" @tap="goTouTiaoSearch">
          <div class="box-icon"></div>
          <div class="box-text">|搜索你感兴趣的测试</div>
        </v-touch>
      </div>
      <!-- 添加壹心理介绍 -->
      <div class="toutiao-extendingCenter-yixinli">
        <div class="yixinli-logo"></div>
        <div class="yixinli-text"></div>
        <v-touch @tap="goYixinliIntroduce" class="yixinli-tis">查看更多</v-touch>
      </div>
      <div class="toutiao-extendingCenter-box toutiao-extendingCenter-app">
        <div class="extendingCenter-box-title">
          <span>产品列表</span>
        </div>
        <div class="extendingCenter-app-list">
          <div class v-for="(one, index) in shareAppList" :key="index">
            <productOne :item="one" @_showCode="inshowCode" :index="index"></productOne>
          </div>
        </div>
      </div>
      <div class="toutiao-extendingCenter-hot">
        <!--热卖爆款-->
        <recomend-list :toutiaoType="true" :indexList="hotList" :type="'hot'" :hidePrice="true"></recomend-list>
      </div>

      <div v-if="isTikTok" class="toutiao-extendingCenter-tip">
        <div class="extendingCenter-box-title">
          <span>新手指南</span>
        </div>
        <div class="toutiao-extendingCenter-tip_text">
          1、打开
          <span>抖音 APP- 搜索 - 扫一扫 - 相册</span>，将推广码放置扫描框，在抖音里打开小程序，并确认授权。
        </div>
        <div class="toutiao-extendingCenter-tip_icon">
          <ul>
            <li>
              <div class="tip_icon_img">
                <img src="../../assets/toutiao/1.png" alt="'打开抖⾳APP'" />
              </div>
              <div class="tip_icon_text">打开抖⾳APP</div>
            </li>
            <li>
              <div class="tip_icon_img">
                <img src="../../assets/toutiao/2.png" alt="'搜索「扫一扫」'" />
              </div>
              <div class="tip_icon_text">搜索「扫一扫」</div>
            </li>
            <li>
              <div class="tip_icon_img">
                <img src="../../assets/toutiao/3.png" alt="'点击相册'" />
              </div>
              <div class="tip_icon_text">点击相册</div>
            </li>
            <li>
              <div class="tip_icon_img">
                <img src="../../assets/toutiao/4.png" alt="'扫推广码'" />
              </div>
              <div class="tip_icon_text">扫推广码</div>
            </li>
          </ul>
        </div>
        <div class="toutiao-extendingCenter-tip_text">
          2、【绑定推广码】保存产品列表里的推广码，打开抖音
          <span>APP-搜索-扫一扫-相册</span>，将推广码放置扫描框，在抖音里打开小程序，点击
          <span>「允许」</span>。
        </div>
        <div class="toutiao-extendingCenter-tip_two-tip">
          <img src="../../assets/toutiao/two-tip.png" alt />
        </div>
        <div v-for="(item, index) in shareAppList" :key="index">
          <div
            class="toutiao-extendingCenter-tip_bind"
            :class="item.isMore2Lines ? 'hidden' : ''"
            :ref="'status' + index"
          >
            <div class="bind-one">
              《{{ item.title }}》绑定状态：
              <template v-if="item.nickNames.length > 0">
                <span :class="item.isMore2Lines ? 'hidden' : ''">
                  <span
                    :class="['bind-name', name.wrong ? 'black' : '']"
                    v-for="(name, indexName) in item.nickNames"
                    :key="indexName"
                  >
                    {{ name }}
                    <span class="bind-icon">
                      {{ indexName == item.nickNames.length - 1 ? '' : '/'
                      }}
                      <span
                        v-if="checkName(name)"
                        class="no-nickName"
                        @click="openNameTips"
                      ></span>
                    </span>
                  </span>
                </span>
              </template>
              <template v-else>
                <span>未绑定</span>
              </template>
            </div>
          </div>
          <v-touch class="btn-all-status" v-if="item.isMore2Lines" @tap="openAllStatus(item)">
            查看全部
            <img src="../../assets/toutiao/btn-bottom.png" alt="查看全部" />
            <span></span>
          </v-touch>
        </div>

        <div class="toutiao-extendingCenter-box-no2">
          <div class="content-no2"></div>
        </div>
      </div>

      <div class="toutiao-extendingCenter-box no3">
        <div class="extendingCenter-box-title">
          <span>收益说明</span>
        </div>
        <div class="toutiao-extendingCenter-box_title title-no3">
          <span class="earning-btn" @click="openTips" v-if="teamStatus == 1 || !isTikTok">
            {{ isTikTok ? '抖音小程序推广分佣比例' : '快手小程序推广分佣说明' }}
            <img src="../../assets/toutiao/earning-tip.png" alt />
          </span>
        </div>
        <div class="content-no3">
          <div class="earning-tip">
            <div class="tip-title">{{ isTikTok ? textConfig.selfSplit : '75%' }}</div>
            <div class="tip-content">{{ isTikTok ? '自己拍抖音赚佣金比例' : '自己拍快手赚佣金比例' }}</div>
          </div>
          <template v-if="teamStatus == 1 && isTikTok">
            <div class="vertical"></div>
            <div class="earning-tip">
              <div class="tip-title">{{ textConfig.teamSplit }}</div>
              <div class="tip-content">团队拍抖音拥金比例</div>
            </div>
          </template>
        </div>
      </div>

      <div class="toutiao-extendingCenter-box">
        <div class="extendingCenter-box-title">
          <span>商务合作</span>
        </div>
        <div class="toutiao-extendingCenter-cooperation">
          <div class="toutiao-extendingCenter-box_title title">
            <P>疑问解答</P>
            <P>请添加微信：</P>
          </div>
          <!--        <div class="customer-service"></div>-->
          <img src="../../assets/toutiao/customer.png" class="customer-service" />
        </div>
      </div>

      <imgDialog v-if="showCodeImg || codeUrl" :hideBtn="true" @closeMoadl="_closeMoadl">
        <img :src="showCodeImg" alt v-if="showCodeImg" />
        <qrCode
          class="qrcodeCont"
          v-if="codeUrl"
          ref="qrcodeTips"
          :propContent="codeUrl"
          :size="2000"
        ></qrCode>
      </imgDialog>
      <!--分佣提示-->
      <div class="commission-tips" v-if="showTips">
        <myMask @click.native="closeTips"></myMask>
        <div class="tips-title"></div>
        <div class="tips-content">
          <div class="content-title">分佣比例说明</div>
          <div class="content-title">{{ isTikTok ? '佣金按照小程序实际产生报告数计算：' : '佣金按照小程序实际产生订单数计算' }}</div>
          <div class="content-box">
            <div class="box-line">
              <span class="text-name">达人自推收益 ：</span>
              <div class="text-info">{{ isTikTok ? `每份报告金额*达人产生报告总数*${textConfig.selfSplit}` : '订单成交金额*75%' }}</div>
            </div>
            <div v-if="isTikTok" class="box-line">
              <span class="text-name">团队推广收益 ：</span>
              <div
                class="text-info info-box"
              >团队每单金额*{{ textConfig.selfSplit }}*{{ textConfig.teamSplit }}（得出每位下级贡献收益后，再进行相加，得出总下级贡献收益）</div>
            </div>
          </div>
        </div>
      </div>
      <!--真实姓名提示-->
      <div class="name-tips" v-if="showNameTips">
        <myMask></myMask>
        <div class="tips-box">
          <div class="box-title">温馨提示</div>
          <div class="box-content">
            这是一个默认昵称，请在抖音app打开该小程序，点击
            <span>右上角-设置-打开用户信息</span>，重新允许授权，然后重启小程序，以此更新您的真实昵称
          </div>
          <div class="box-btn" @click="closeNameTips">我知道了</div>
        </div>
      </div>
    </div>

    <!-- 平台切换按钮 -->
    <div
      class="toutitao-switch" 
      :class="isTikTok ? 'is-tiktok' : 'is-kwai'"
      @click="handleSwitch"
    >
      <span>{{ isTikTok ? '抖音平台' : '快手平台' }}</span>
      <i></i>
    </div>

    <cp-dialog
      v-if="kwaiNoBindTips"
      title="温馨提示"
      buttonText="复制"
      @close="kwaiNoBindTips = false"
      @click="copyText('yixinlidudu')"
    >
      <div>请先联系客服在后台绑定快手ID后方可操作查看，客服微信号：yixinlidudu</div>
    </cp-dialog>

    <!-- 资料包 -->
    <div
      v-if="isTikTok"
      class="toutiao-extengdingCenter-datagram"
      ref="copyBtn"
      :data-clipboard-text="'yixinlidudu'"
    ></div>
    <packageDialog v-if="PACKAGEPOP_STATUS" @_closeModal="PACKAGEPOP_STATUS = false"></packageDialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import pageMixin from '@/mixins/pageMixin'
import recomendList from '@/components/show/index/testSwiper.vue'
import imgDialog from '@/components/imgDialog'
import myMask from '@/components/common/mask.vue'
import toutiaojson from './toutiaojson'
import APIS from '../../apis'
import qrCode from '@/components/common/qrCodeMaker'
import toutiaoMixin from '@/mixins/toutiaoMixin'
import productOne from '@/components/toutiao/productOne'
import packageDialog from '@/components/toutiao/packageDialog'
import Clipboard from 'clipboard'
import cpDialog from '@/components/cp-dialog'

const TEXT_CONFIG = {
  before: {
    teamSplit: '12%',
    selfSplit: '75%'
  },
  after: {
    teamSplit: '8%',
    selfSplit: '85%'
  }
}

export default {
  mixins: [pageMixin, toutiaoMixin],
  components: {
    myMask,
    recomendList,
    imgDialog,
    qrCode,
    productOne,
    packageDialog,
    cpDialog
  },
  data() {
    return {
      showCodeImg: '',
      shareList: toutiaojson.shareList,
      byteDanceAppName: '壹心理测评',
      hasBind: 0,
      nickNames: '',
      isMore2Lines: false,
      showTips: false,
      teamStatus: 0, // 1是开 0 是关
      tatisticData: {
        videoViewStatNum: 10,
        createOrderStatNum: 0,
        playOrderStatNum: 0
      },
      promoUser: '',
      shareAppList: [],
      showNameTips: false, // 真实姓名提示
      //二维码链接
      codeUrl: '',
      PACKAGEPOP_STATUS: false, //推广中心资料包弹窗控制
      kwaiNoBindTips: false
    }
  },
  watch: {},
  props: {},
  computed: {
    ...mapGetters(['extendPlatform']),
    wxShareConfig() {
      return {
        title: `如何在视频里挂载小程序？`,
        link: `${location.origin}${location.pathname}#/extendingCenter?channelId=${this.channelId}`,
        imgUrl:
          'https://imgco.xinli001.com/ceping/resources/images/trinyMCE/cc17f28cb20040698337e6cea453ea47.jpg',
        desc: `壹心理测评抖音小程序上线啦！`,
        success: function() {},
        cancel: function() {}
      }
    },

    textConfig() {
      const isAfter = new Date() > new Date('2020/08/01 00:00')
      return TEXT_CONFIG[isAfter ? 'after' : 'before']
    },

    isTikTok () {
      return this.extendPlatform === 'tiktok'
    },

    hotList () {
      if (this.isTikTok) {
        return toutiaojson.hotList
      }
      return toutiaojson.kwaiHotList
    }
  },
  created() {
    this.toTop()
    this.initMiniAppList()
  },
  mounted() {
    const that = this
    //获取头条用户信息

    var params = {
      channelId: that.channelId
    }
    if (that.$route.query.recommendUserKey) {
      params.recommendUserKey = that.$route.query.recommendUserKey
    }
    if (that.$route.query.force) {
        params.force = that.$route.query.force
    }
    that
      .promoGetUser({
        params: params
      })
      .then(res => {
        if (res.code == 1) {
          sessionStorage.setItem('promoSign', res.data.sign)
          that.teamStatus = res.data.status
          that.promoUser = res.data.userKey
          console.log('获取用户信息成功 res', res)
          that.bindToutiaoRecommendUserKey()
          that.fetchStatisticData()
          that.fetchPromoPackagePop()
          that.initCopyBtn()
        }

        // that.getAuthQrCode()
      })
  },
  methods: {
    ...mapActions([
      'pullHotScales',
      'promoGetUser',
      'promoQrcodeList',
      'promoGetQrCode',
      'getBindToutiaoUsers',
      'getStatisticData',
      'promoAuthUrl',
      'promoAppList',
      'promoPackagePop'
    ]),
    ...mapMutations(['switchPlatform']),
    gettouTiaoUser(type) {
      const that = this
      const paramType = type !== undefined ? type : (this.isTikTok ? 0 : 1)
      return that
        .getBindToutiaoUsers({
          params: {
            channelId: that.channelId,
            type: paramType
          }
        })
        .then(res => {
          if (res.data && res.data.length && res.data.length > 0 && paramType === 0) {
            res.data.forEach((item, index) => {
              for (let i = 0; i < that.shareAppList.length; i++) {
                let app = that.shareAppList[i]
                if (app.appCode == item.appCode) {
                  app['hasBind'] = item.hasBind
                  app['nickNames'] = item.nickNames
                }
              }
            })
            console.log('绑定抖音号信息 shareAppList', that.shareAppList)
          }
          if (this.isTikTok) {
            that.$nextTick(() => {
              that.checkMore2Lines()
            })
          }
          return res
        })
    },
    initMiniAppList() {
      const that = this
      this.promoAppList({
        params: {}
      }).then(res => {
        console.log(res)
        if (res.code == 1) {
          this.shareAppList = res.data
            .map(app => {
              let r = {}
              r.appCode = app.appCode
              r.channelId = app.channelId
              r.title = app.name
              r.logo = app.logoUrl
              r.hasBind = 0
              r.nickNames = []
              r.promoScaleVoList = app.promoScaleVoList
              r.authUrl = app.authUrl
              r.description = app.description
              return r
            })
            .filter(item => !!item)
          that.gettouTiaoUser()
        }
      })
    },
    getAuthQrCode() {
      this.promoAuthUrl({
        params: {}
      }).then(res => {
        console.log(res)
        if (res.code == 1) {
          this.codeUrl = res.data
        }
      })
    },
    openNameTips() {
      this.showNameTips = true
    },
    closeNameTips() {
      this.showNameTips = false
    },
    openTips() {
      this.showTips = true
    },
    closeTips() {
      this.showTips = false
    },
    fetchStatisticData() {
      this.getStatisticData({
        params: {
          channelId: this.channelId
        }
      }).then(res => {
        console.log('--- 推广中心-统计数据 ---', res)
        if (res.code == 1) {
          this.tatisticData = res.data
        }
      })
    },
    bindToutiaoRecommendUserKey() {
      const that = this
      console.log(
        'bindToutiaoRecommendUserKey',
        this.$route.query.recommendUserKey
      )
      if (this.$route.query.recommendUserKey) {
        this.promoBind({
          params: {
            recommendUserKey: this.$route.query.recommendUserKey,
            channelId: that.channelId
          }
        }).then(res => {
          console.log(res)
          if (res.code != 44004) {
            that.setTOASTTEXT(res.msg)
          }
        })
      }
    },
    goMyEarnings() {
      location.href = `${location.protocol}//${APIS.toutiaoShareHost}/cp/index.html?init=17#/myEarnings?channelId=${this.channelId}&teamStatus=${this.teamStatus}&promoUser=${this.promoUser}`
    },
    inshowCode(item) {
      console.log('-----------inshowCode')
      console.log(item)
      this.codeUrl = item.authUrl
    },
    checkMore2Lines() {
      const that = this
      if (this.shareAppList && this.shareAppList.length > 1) {
        that.shareAppList.map((item, index) => {
          if (this.$refs['status' + index][0]) {
            let e = this.$refs['status' + index][0]
            let hight = e.offsetHeight || e.clientHeight
            let lineHeight = Number(
              window.getComputedStyle(e)['lineHeight'].slice(0, 2)
            )
            that.shareAppList[index].isMore2Lines = hight / lineHeight > 2
          }
        })
      }

    },
    openAllStatus(item) {
      item.isMore2Lines = false
    },
    goTouTiaoSearch() {
      this.$router.push({
        path: './ttSearch',
        query: {
          channelId: this.channelId,
          force: this.$route.query.force,
        }
      })
    },
    goYixinliIntroduce() {
      this.$router.push({
        path: './yixinliIntroduce',
        query: {
          channelId: this.channelId,
          force: this.$route.query.force,
        }
      })
    },
    _closeMoadl() {
      this.showCodeImg = ''
      this.codeUrl = ''
    },
    _showAuthCode() {
      this.getAuthQrCode()
    },
    checkName(name) {
      if (name.indexOf('小鲸鱼') != -1) {
        return true
      } else {
        return false
      }
    },
    fetchPromoPackagePop() {
      const that = this
      that
        .promoPackagePop({
          params: {}
        })
        .then(res => {
          if (res.code == 1) {
            that.PACKAGEPOP_STATUS = !!res.data.pop
          }
        })
    },
    initCopyBtn(id, title) {
      console.log('点击复制')
      this.$nextTick(() => {
        if (this.$refs.copyBtn) {
          let clipboard = new Clipboard(this.$refs.copyBtn)
          clipboard.on('success', (e) => {
            e.clearSelection()
            this.setTOASTTEXT({ str: '微信号已复制' })
          }) 
        }
      })

    },

    async handleSwitch () {
      const { data } = await this.gettouTiaoUser(this.isTikTok ? 1 : 0)
      if (!data.length && this.isTikTok) {
        this.kwaiNoBindTips = true
        return
      }
      this.switchPlatform(this.isTikTok ? 'kwai' : 'tiktok')
      this.toTop()
    },

    copyText (content) {
      this._copyText(content, () => {
        this.setTOASTTEXT('复制成功')
      })
    }
  },
  filters: {
    bindName(name) {
      let t = ''
      if (name.hasBind == 1 && name.nickNames) {
        t = name.nickNames
      }
      return nickNames
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/function';
@import '../../scss/config';
.toutiao {
  background: #fff8dd;
  position: relative;
  &:before {
    content: '';
    width: topx(211rem);
    height: topx(138rem);
    position: absolute;
    top: topx(129rem);
    right: 0;
    z-index: 1;
    background: url('../../assets/toutiao/yixinlibox_bg.png') no-repeat center;
    background-size: 100% 100%;
  }
}
.toutiao-extendingCenter {
  width: topx(750rem);
  height: auto;
  background: url('../../assets/toutiao/extendingCenter-top.png') no-repeat
    center;
  background-size: topx(750rem) topx(536rem);
  background-position: 0 0;
  overflow: hidden;
  padding-bottom: topx(80rem);
  .toutiao-extendingCenter-search {
    margin-top: topx(30rem);
    .search-box {
      width: topx(690rem);
      height: topx(98rem);
      border-radius: topx(49rem);
      background: #FFFFFF;
      margin: auto;
      display: flex;
      align-items: center;
      .box-icon {
        width: topx(25rem);
        height: topx(27rem);
        background: url('../../assets/toutiao/icon-search.png') no-repeat center;
        background-size: 100%;
        margin-left: topx(24rem);
      }
      .box-text {
        font-size: topx(28rem);
        color: #999999;
        line-height: topx(28rem);
        margin-left: topx(20rem);
      }
    }
  }
  .toutiao-extendingCenter-introduce {
    .title {
      margin: topx(175rem) topx(40rem) topx(20rem);
      font-weight: bold;
      font-size: topx(60rem);
      color: #613e1f;
      letter-spacing: 0;
      line-height: topx(60rem);
    }
    .text {
      font-size: topx(36rem);
      color: #613e1f;
      letter-spacing: 0;
      line-height: topx(49rem);
      margin: 0 topx(14rem) topx(50rem) topx(14rem);
      span {
        font-weight: bold;
        line-height: topx(50rem);
      }
    }
  }

  .toutiao-extendingCenter-yixinli {
    width: topx(690rem);
    /*height: topx(517rem);*/
    margin: topx(30rem) auto 0;
    padding-bottom: topx(9rem);
    background: #ffffff;
    box-shadow: 0 topx(10rem) topx(20rem) topx(-12rem) #ffc500;
    border-radius: topx(26rem);
    overflow: hidden;
    position: relative;
    padding-bottom: topx(30rem);
    .yixinli-logo {
      width: topx(180rem);
      height: topx(51rem);
      background: url('../../assets/toutiao/yixinli-logo.png') no-repeat center;
      background-size: 100% 100%;
      margin: topx(30rem) 0 topx(40rem) topx(30rem);
    }
    .yixinli-text {
      width: topx(629rem);
      height: topx(181rem);
      background: url('../../assets/toutiao/yixinli-text.png') no-repeat center;
      background-size: 100% 100%;
      margin: 0 auto;
    }
    .yixinli-tis {
      height: topx(28rem);
      font-size: topx(28rem);
      line-height: topx(28rem);
      color: #6982fa;
      position: relative;
      margin: topx(20rem) topx(35rem) 0 topx(35rem);
      text-align: right;
      &:after {
        content: '';
        display: inline-block;
        width: topx(9rem);
        height: topx(19rem);
        background: url('../../assets/icon-more-blue.svg') no-repeat center;
        background-size: 100% 100%;
        margin-left: topx(10rem);
      }
    }
  }

  .toutiao-extendingCenter-tip {
    width: topx(690rem);
    /*height: topx(517rem);*/
    margin: topx(40rem) auto 0;
    padding-bottom: topx(9rem);
    background: #ffffff;
    box-shadow: 0 topx(10rem) topx(20rem) topx(-12rem) #ffc500;
    border-radius: topx(26rem);
    overflow: hidden;
    &_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: topx(37rem) topx(40rem) 0 topx(22rem);
      .title-text {
        font-size: topx(32rem);
        color: #4c4b58;
        letter-spacing: 0;
        line-height: topx(57rem);
      }
      .title-btn {
        width: topx(270rem);
        height: topx(90rem);
        background: url('../../assets/toutiao/btn-download.png') no-repeat
          center;
        background-size: topx(270rem) topx(90rem);
      }
    }
    &_text {
      font-size: topx(32rem);
      line-height: topx(45rem);
      color: #4c4b58;
      letter-spacing: 0;
      margin: topx(8rem) topx(24rem) 0 topx(22rem);
      span {
        font-weight: bold;
      }
    }
    &_icon {
      margin: topx(37rem) 0 topx(30rem) 0;
      ul {
        display: flex;
        li {
          width: topx(300rem);
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          position: relative;
          &:after {
            content: '';
            display: inline-block;
            width: topx(10rem);
            height: topx(10rem);
            border-width: topx(2rem) topx(2rem) 0 0;
            transform: rotate(45deg);
            border-style: solid;
            border-color: #999999;
            position: absolute;
            right: topx(-8rem);
            top: 40%;
            margin-top: topx(-7rem);
          }
        }
      }
      .tip_icon_img {
        width: topx(110rem);
        height: topx(128rem);
        overflow: hidden;
        img {
          width: 100%;
          height: auto;
        }
      }
      .tip_icon_text {
        text-align: center;
        font-size: topx(24rem);
        color: #63636b;
        letter-spacing: 0;
        line-height: topx(20rem);
        margin-top: topx(20rem);
      }
    }
    &_authorization {
      padding-bottom: topx(44rem);
      display: flex;
      justify-content: center;
      img {
        width: topx(216rem);
        height: topx(72rem);
        background: no-repeat center;
        background-size: 100% 100%;
      }
    }
    &_two-tip {
      padding: topx(20rem) 0 topx(40rem) 0;
      display: flex;
      justify-content: center;
      img {
        width: topx(622rem);
        height: topx(175rem);
        background: no-repeat center;
        background-size: 100% 100%;
      }
    }
    &_bind {
      padding: 0 topx(24rem) 0 topx(50rem);
      font-size: topx(28rem);
      color: #63636b;
      letter-spacing: 0;
      line-height: topx(62rem);
      .bind-one {
        position: relative;
        span {
          color: #939799;
        }
        &:before {
          content: '';
          width: topx(10rem);
          height: topx(10rem);
          display: inline-block;
          background: #ffdd2b;
          border-radius: 100%;
          position: absolute;
          left: topx(-14rem);
          top: topx(26rem);
        }
        .bind-name {
          position: relative;
          &.black {
            color: #63636b;
          }
          .bind-icon {
            position: relative;
            .no-nickName {
              width: topx(24rem);
              height: topx(24rem);
              background: url('../../assets/toutiao/earning-tip.png') no-repeat
                scroll right center transparent;
              background-size: 100% 100%;
              position: absolute;
              top: topx(-18rem);
              right: topx(2rem);
            }
          }
        }
      }
      &.hidden {
        overflow: hidden;
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2; /*要显示的行数*/
        -webkit-box-orient: vertical;
      }
      span {
        color: #939799;
      }
    }
    .btn-all-status {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: topx(15rem) 0;
      font-size: topx(24rem);
      color: #939799;
      letter-spacing: 0;
      line-height: topx(24rem);
      img {
        width: topx(16rem);
        height: topx(9rem);
        padding-left: topx(14rem);
        margin-left: topx(6rem);
      }
    }
  }
  .toutiao-extendingCenter-share {
    margin: topx(60rem) topx(30rem) topx(20rem) topx(30rem);
  }
  .toutiao-extendingCenter-box {
    width: topx(630rem);
    height: auto;
    margin: topx(30rem) auto 0;
    background: #ffffff;
    box-shadow: 0 topx(10rem) topx(20rem) topx(-12rem) #ffc500;
    border-radius: topx(26rem);
    overflow: hidden;
    padding: topx(40rem);
    &_title {
      font-size: topx(32rem);
      color: #4c4b58;
      letter-spacing: 0;
      font-weight: bolder;
    }
    &_img {
      width: topx(600rem);
      height: topx(1200rem);
      margin: topx(30rem) topx(15rem) 0 topx(15rem);
      overflow: hidden;
      img {
        width: 100%;
        height: auto;
      }
    }
    &_btn {
      width: topx(630rem);
      height: topx(116rem);
      background: url('../../assets/toutiao/icon_myincome.png') no-repeat center;
      background-size: 100% 100%;
    }
    &.no3 {
      .title-no3 {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: topx(39rem);
        .title {
          font-size: topx(32rem);
          line-height: topx(45rem);
          color: #4c4b58;
        }
        .earning-btn {
          font-size: topx(24rem);
          font-weight: normal;
          line-height: topx(24rem);
          color: #ff6f6f;
          display: flex;
          align-items: center;
          img {
            width: topx(24rem);
            height: topx(24rem);
            margin-left: topx(6rem);
          }
        }
      }
      .content-no3 {
        display: flex;
        justify-content: space-around;
        margin-bottom: topx(10rem);
        .earning-tip {
          display: flex;
          align-items: center;
          flex-direction: column;
          font-weight: normal;
          .tip-title {
            margin: topx(5rem) 0 topx(22rem);
            font-size: topx(28rem);
            line-height: topx(28rem);
            font-weight: normal;
            color: #ff6f6f;
          }
          .tip-content {
            display: -webkit-box;
            -webkit-line-clamp: 2;
            text-align: center;
            color: #63636b;
          }
        }
        .vertical {
          border-left: topx(2rem) solid #f0f0f0;
          margin: 0 topx(11rem);
        }
      }
      .content-earning {
        padding: topx(60rem) 0 topx(30rem) 0;
        display: flex;
        justify-content: space-around;
        align-items: flex-end;
        .earning-box {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .sign {
          height: topx(24rem);
          border-left: topx(2rem) solid #f0f0f0;
        }
        .box-number {
          font-size: topx(24rem);
          line-height: topx(28rem);
          padding-bottom: topx(28rem);
          color: #4c4b58;
        }
        .box-name {
          font-size: topx(24rem);
          line-height: topx(24rem);
          color: #999999;
        }
      }
    }
  }
  .toutiao-extendingCenter-box-no2 {
    color: #4c4b58;
    padding: 0 topx(25rem);
    margin: topx(48rem) 0;
    .content-no2 {
      width: topx(626rem);
      height: topx(255rem);
      background: url('../../assets/toutiao/extendingCenter-no2.png') no-repeat
        center;
      background-size: 100% 100%;
    }
  }
  .extendingCenter-box-title {
    height: topx(100rem);
    text-align: center;
    span {
      font-size: topx(38rem);
      color: #4c4b58;
      line-height: topx(100rem);
      font-weight: bolder;
      padding: 0 topx(50rem);
      position: relative;
      &:before {
        content: '';
        width: topx(45rem);
        height: topx(4rem);
        background: #f0f0f0;
        position: absolute;
        top: 50%;
        left: 100%;
      }
      &:after {
        content: '';
        width: topx(45rem);
        height: topx(4rem);
        background: #f0f0f0;
        position: absolute;
        top: 50%;
        right: 100%;
      }
    }
  }
  .extendingCenter-app-list {
    overflow: hidden;
    .extendingCenter-app-one {
      height: topx(150rem);
      display: flex;
      position: relative;
      border-bottom: topx(2rem) solid #f0f0f0;
      &-logo {
        width: topx(60rem);
        height: topx(60rem);
        margin: topx(45rem) 0 0 0;
        overflow: hidden;
        img {
          width: 100%;
          height: auto;
        }
      }
      &-title {
        line-height: topx(150rem);
        font-size: topx(32rem);
        color: #4c4b58;
        margin-left: topx(16rem);
        font-weight: bolder;
      }
      &-code {
        width: topx(270rem);
        height: topx(90rem);
        background: url('../../assets/toutiao/btn-download.png') no-repeat
          center;
        background-size: topx(270rem) topx(90rem);
        position: absolute;
        top: 50%;
        right: 0;
        margin-top: topx(-45rem);
      }
    }
    .split-bottom {
      border-bottom: none;
    }
  }
  .toutiao-extendingCenter-cooperation {
    display: flex;
    justify-content: space-between;
    padding: topx(15rem) topx(30rem);
    .title {
      display: flex;
      justify-content: center;
      /* align-items: center; */
      flex-direction: column;
    }
    .cooperation-title {
      padding: topx(17rem) 0;
      line-height: topx(45rem);
      width: topx(397rem);
    }
    .customer-service {
      width: topx(124rem);
      height: topx(124rem);
      border-radius: topx(8rem);
    }
  }
}
.commission-tips {
  width: topx(600rem);
  position: fixed;
  top: topx(174rem);
  left: topx(86rem);
  right: topx(64rem);
  z-index: 4;
  .tips-title {
    position: relative;
    z-index: 10;
    width: topx(600rem);
    height: topx(200rem);
    background: url('../../assets/toutiao/tips-top.png') no-repeat center;
    background-size: 100% 100%;
  }
  .tips-content {
    position: relative;
    z-index: 10;
    background: #ffffff;
    padding: topx(30rem) topx(39rem) topx(40rem);
    border-radius: 0 0 topx(26rem) topx(26rem);
    .content-title {
      font-size: topx(28rem);
      line-height: topx(42rem);
      color: #4c4b58;
    }
    .content-box {
      padding-top: topx(23rem);
      .box-line {
        display: flex;
        /*padding-bottom: topx(14rem);*/
        .text-name {
          font-size: topx(28rem);
          line-height: topx(42rem);
          color: #939799;
          white-space: nowrap;
        }
        .text-info {
          font-size: topx(28rem);
          line-height: topx(42rem);
          color: #4c4b58;
        }
      }
    }
  }
}
.name-tips {
  width: topx(556rem);
  position: fixed;
  top: topx(174rem);
  left: topx(97rem);
  right: topx(97rem);
  .tips-box {
    width: 100%;
    height: auto;
    position: relative;
    z-index: 10;
    border-radius: topx(26rem);
    background: #ffffff;
    padding-bottom: topx(50rem);
    display: flex;
    flex-direction: column;
    align-items: center;
    .box-title {
      padding-top: topx(40rem);
      font-size: topx(38rem);
      line-height: topx(38rem);
      font-weight: bold;
      color: #333333;
    }
    .box-content {
      padding: topx(36rem) topx(63rem) topx(20rem);
      font-size: topx(32rem);
      line-height: topx(45rem);
      color: #63636b;
      span {
        font-weight: bold;
        color: #4c4b58;
      }
    }
    .box-btn {
      /*margin-bottom: topx(50rem);*/
      font-size: topx(32rem);
      line-height: topx(69rem);
      text-align: center;
      font-weight: bold;
      color: #613e1f;
      width: topx(254rem);
      height: topx(69rem);
      background: linear-gradient(
        180deg,
        rgba(255, 230, 54, 1) 0%,
        rgba(255, 214, 59, 1) 100%
      );
      border-radius: topx(8rem);
    }
  }
}
.qrcodeCont {
  width: topx(500rem);
  height: topx(500rem);
  padding: topx(10rem);
  margin: 0 auto topx(60rem) auto;
  img {
    width: 100%;
  }
}
.toutiao-extengdingCenter-datagram {
  width: topx(120rem);
  height: topx(106rem);
  background: url('../../assets/toutiao/datagram.png') no-repeat center;
  background-size: 100% 100%;
  position: fixed;
  top: topx(318rem);
  right: topx(30rem);
}

.toutitao-switch {
  position: fixed;
  left: 0;
  top: topx(600rem);
  width: topx(190rem);
  height: topx(64rem);
  border-radius: 0 topx(100rem) topx(100rem) 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: topx(28rem);

  i {
    display: inline-block;
    height: 100%;
    width: topx(28rem);
    margin-left: topx(10rem);
  }

  &.is-tiktok {
    background: #FF546E;

    i {
      background: url(~@/assets/toutiao/icon-switch-tiktok.png) no-repeat center center;
      background-size: contain;
    }
  }

  &.is-kwai {
    background: #FF6C3A;

    i {
      background: url(~@/assets/toutiao/icon-switch-kwai.png) no-repeat center center;
      background-size: contain;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/toutiaoApp/extendingCenter.vue